const justValidate = require("just-validate");
module.exports = function (element) {
    let err_class = 'auth__input__invalid'

    let firebase = require('firebase/compat/app')
    require('firebase/compat/auth')
    let providers = {
        'facebook.com': new firebase.auth.FacebookAuthProvider().addScope('email'),
        'google.com': new firebase.auth.GoogleAuthProvider(),
        'twitter.com': new firebase.auth.TwitterAuthProvider(),
    };

    firebase.initializeApp({
        apiKey: "AIzaSyCP3HLYnj2-8qhu89O92FOm2h9LICI6Iuo",
        authDomain: "goodfonweb.firebaseapp.com",
        projectId: "goodfonweb",
        messagingSenderId: "81648000881",
    });

    var doBackAuth = function () {
        return new Promise(function (resolve, reject) {
            firebase.auth().currentUser.getIdToken(true).then(function (idToken) {
                $.post('/auth/oauth/', {'token': idToken}).done(function () {
                    resolve()
                }).fail(function (e) {
                    reject(e);
                });
            });
        })
    }

    var doAuth = function (provider) {
        return new Promise(function (resolve, reject) {
            firebase.auth().signInWithPopup(provider).then(function () {
                doBackAuth().then(function () {
                    resolve()
                });
            }).catch(function (error) {
                if (error.code === 'auth/account-exists-with-different-credential') {
                    $.post('/auth/oauth_credential/', {'email': error.email}).done(function (res) {
                        firebase.auth().signInWithPopup(providers[res.result]).then(function (result) {
                            result.user.linkWithPopup(provider).then(function () {
                                doBackAuth().then(function () {
                                    resolve()
                                });
                            });
                        });
                    });
                }
            });
        });
    }

    var authOrLink = function (provider) {
        return new Promise(function (resolve, reject) {
            var user = firebase.auth().currentUser;

            if (user) {
                for (var i = 0; i < user.providerData.length; i++) {
                    if (user.providerData[i].providerId === provider.providerId) {
                        doAuth(provider).then(function () {
                            resolve()
                        });
                        return;
                    }
                }

                user.linkWithPopup(provider).then(function () {
                    doBackAuth().then(function () {
                        resolve()
                    });
                });
            } else {
                doAuth(provider).then(function () {
                    resolve()
                });
            }
        });
    }

    var authUnlink = function (provider) {
        return new Promise(function (resolve, reject) {
            firebase.auth().onAuthStateChanged(function (user) {
                if (user) {
                    user.unlink(provider).then(function (res) {
                        doBackAuth().then(function () {
                            resolve();
                        });
                    }).catch(function (e) {
                        reject(e);
                    });
                }
            });
        });
    }

    function authBlock(el) {
        let node = $(el);
        let submitBtn = node.find('.js-auth-submit')

        if (node.find('.js-auth-signin').length) {
            let signinForm = new justValidate('.js-auth-signin', {
                validateBeforeSubmitting: true,
                errorsContainer: '.js-auth-validate_err',
                errorFieldCssClass: err_class,
            })
            signinForm.addField('[name=login]', [
                {
                    rule: 'required',
                },
                {
                    rule: 'customRegexp',
                    value: /^[0-9a-z\-_]+$/,
                },
                {
                    rule: 'minLength',
                    value: 4,
                },
                {
                    rule: 'maxLength',
                    value: 15,
                },
            ]).onValidate(({isValid}) => {
                submitBtn.attr('disabled', !isValid)
            }).addField('[name=password]', [
                {
                    rule: 'required',
                },
                {
                    rule: 'minLength',
                    value: 5,
                },
                {
                    rule: 'maxLength',
                    value: 20,
                }
            ]).onSuccess((event) => {
                let form = $(event.currentTarget)
                form.find('.js-auth-csrf').load("/auth/signin/ input[name='csrfmiddlewaretoken']", function () {
                    $.post(form.attr('action'), form.serialize(), function (data) {
                        if (data.status === 'error') {
                            signinForm.showErrors({'[name=login]': '', '[name=password]': ''})
                            form.find('.js-auth-txt_err').show()
                        } else if (data.status === 'success') {
                            location.reload()
                        }
                    })
                })
            })
        }

        let authPwdButton = node.find('.js-auth-pwd-show')
        authPwdButton.on('click', function (e) {
            authPwdButton.toggleClass('headline__pwd__icon__hide');
            node.find('.js-auth-pwd-input').prop('type', function (i, val) {
                return val === "password" ? 'text' : 'password'
            })

            e.preventDefault();
        })

        node.find('.fb_login').on("click", function (e) {
            authOrLink(providers['facebook.com']).then(function () {
                location.reload();
            });

            e.preventDefault();
        });

        node.find('.gl_login').on("click", function (e) {
            authOrLink(providers['google.com']).then(function () {
                location.reload();
            });

            e.preventDefault();
        });

        node.find('.tw_login').on("click", function (e) {
            authOrLink(providers['twitter.com']).then(function () {
                location.reload();
            });

            e.preventDefault();
        });
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    authBlock(element);
};